import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { ICreateJobForm } from '@/Models'

AxiosInterceptor()

const careerService = {
  index: (pageNumber: number, sortOrder?: string, status?: string) => {
    return axios.get('/v2/admin/jobs', {
      params: {
        pageNumber,
        sortOrder,
        ...(status && { status }),
      },
    })
  },

  async getSingleJob(id: string) {
    return axios.get(`/v2/admin/jobs/${id}`)
  },

  async createJob(data: any) {
    return axios.post('/v2/admin/jobs', data)
  },
  async updateJob(id: any, data: any) {
    return axios.put(`/v2/admin/jobs/${id}`, data)
  },
  async deleteJob(id: any) {
    return axios.delete(`/v2/admin/jobs/${id}`)
  },
  async updateJobStatus(id: any, status: string) {
    return axios.put(`/v2/admin/jobs/${id}`, status)
  },

  async getJobApplicationsSubmitted() {
    return axios.get('/v2/admin/jobs/applications')
  },
  async getSingleJobApplicationsSubmitted(id: string) {
    return axios.get(`/v2/admin/jobs/applications/${id}`)
  },
}
export default careerService
